/**
 * Expose React router history methods names.
 */
export const historyMethods = Object.freeze({ PUSH: "push", REPLACE: "replace", GO_BACK: "goBack" });
